module.exports = __webpack_public_path__ + "modelace-postavy-liposukce_16_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/modelace-postavy-liposukce_16_after.jpg
// module id = 1095
// module chunks = 0